// Every attack the character can make. A usage GCS resolved no level for reads "no skill"
// and carries no roll, and a conditional modifier is printed in words beside the stats.

import type { Panel, PanelAttack } from "../vendor/web";

export function weaponList(panel: Panel): HTMLElement {
  const wrapper = document.createElement("div");
  wrapper.className = "weapons";

  const advisory = panel.hands_advisory;
  if (advisory !== undefined) {
    const line = document.createElement("p");
    line.className = "weapon-advisory";
    line.textContent = advisory;
    wrapper.append(line);
  }

  const list = document.createElement("ul");
  list.className = "weapon-list";
  for (const attack of panel.attacks) {
    list.append(weaponRow(attack));
  }
  wrapper.append(list);
  return wrapper;
}

function weaponRow(attack: PanelAttack): HTMLElement {
  const level = attack.level;
  const item = document.createElement("li");
  item.className = level === undefined ? "weapon-row weapon-row-unskilled" : "weapon-row";
  item.dataset["usage"] = attack.name;

  const name = span("weapon-name", attack.name);
  const roll = span("weapon-level", level === undefined ? unskilled(attack) : String(level));
  item.append(name, roll);

  const stats = document.createElement("div");
  stats.className = "weapon-stats";
  for (const [label, value] of readings(attack)) {
    stats.append(stat(label, value));
  }
  item.append(stats);

  if (attack.conditional !== "") {
    item.append(span("weapon-conditional", attack.conditional));
  }
  return item;
}

/** GCS declines to chain a default through a skill the character lacks, so it names them. */
function unskilled(attack: PanelAttack): string {
  return attack.defaults.length === 0 ? "no skill" : `no skill: ${attack.defaults.join(", ")}`;
}

function readings(attack: PanelAttack): [string, string][] {
  const out: [string, string][] = [["", attack.damage]];
  if (attack.range !== "") out.push(["Range", attack.range]);
  if (attack.reach !== "") out.push(["Reach", attack.reach]);
  if (attack.accuracy !== "") out.push(["Acc", attack.accuracy]);
  if (attack.parry !== "") out.push(["Parry", attack.parry]);
  if (attack.block !== "") out.push(["Block", attack.block]);
  if (attack.shield_db > 0) out.push(["DB", `+${attack.shield_db}`]);
  return out;
}

function stat(label: string, value: string): HTMLElement {
  const wrapper = document.createElement("span");
  wrapper.className = "weapon-stat";
  if (label !== "") {
    wrapper.append(span("weapon-stat-label", label));
  }
  wrapper.append(span("weapon-stat-value", value));
  return wrapper;
}

function span(className: string, text: string): HTMLElement {
  const element = document.createElement("span");
  element.className = className;
  element.textContent = text;
  return element;
}
